import { GatsbySSR } from 'gatsby';
import React from 'react';
import { AuthProvider } from './src/context/AuthContext';

export const wrapPageElement: GatsbySSR['wrapPageElement'] = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
);
